"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _AaChipsWrapper = _interopRequireDefault(require("./AaChipsWrapper.component"));

var _crossPlatformComponents = require("@airasia/cross-platform-components");

var AaChipsHolder = function AaChipsHolder(props) {
  var destinationRecentSearches = props.destinationRecentSearches,
      icon = props.icon;
  var topRecentSearches = destinationRecentSearches && destinationRecentSearches.length >= 20 ? destinationRecentSearches.slice(0, 19) : destinationRecentSearches;

  var handleClick = function handleClick(item) {
    /*
    *returns destination recent search details of specific chip.
     */
    props.selectRecentSearchDestination(item);
  };

  return /*#__PURE__*/_react["default"].createElement(_AaChipsWrapper["default"], null, topRecentSearches && topRecentSearches.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaChips, {
      key: index,
      data: {
        text: item.name,
        icon: icon
      },
      controls: {
        config: {
          onChipPress: function onChipPress() {
            return handleClick(item);
          }
        }
      }
    });
  }));
};

var _default = AaChipsHolder;
exports["default"] = _default;